import template from "./bSearchAndSelect.html";

export function bSearchAndSelectDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bSearchAndSelectController,
    controllerAs: 'bSearchAndSelect',
    bindToController: true,
    scope: {
      data: "=",
      name: "@",
      select: "=?",
      match: "=?",
      actionAfterSelect: "&",
      placeholder: "=",
      displayExtraField: "&"
    }
  };

  return directive;
}

class bSearchAndSelectController {
  constructor() {
    'ngInject';
  }

  selectItem(select, fActionAfterSelect) {
    this.select = {...this.select, ...select};
    this.search = false;
    fActionAfterSelect({select});
  }

}
